var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('c-modal',{on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"language-selector"},[_c('c-language-and-target')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }